import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import UserService from "../services/user.service";
import OrderService from "../services/order.service";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import { submittedOrder, updatedBalance, clearCart, getCurrentOrder } from '../reducers/cart';
import { getUser, reloadUser, getSubsite } from '../reducers/auth';
import Table from 'react-bootstrap/Table';
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';
import { resolveImageUrl } from '../utils/imageUrl';
import { resolveRetailHomePath } from '../utils/retailHome';

const PRICING_TYPES = {
  FLAT: 1,
  QUANTITY: 2,
  BILL_LATER: 3
};

const Confirm = () => {
    const apiUrl = process.env.REACT_APP_LOCALHOST_URL;
    const { state } = useLocation();
    const navigate = useNavigate();
    const [order, setOrder] = useState(null);
    const [isDemo, setIsDemo] = useState(false);
    const [homePath, setHomePath] = useState('/featured');
    const user = useSelector(getUser);
    const dispatch = useDispatch();
    const currentSubsite = useSelector(getSubsite);

    useEffect(() => {
      let cancelled = false;
      resolveRetailHomePath(currentSubsite).then((path) => {
        if (!cancelled) setHomePath(path);
      });
      return () => { cancelled = true; };
    }, [currentSubsite]);
    useEffect(() => {
        console.log("ORDER ID", state);
        async function fetchData() {
            // Check if this is a demo order
            if (state?.isDemo) {
                setIsDemo(true);
                dispatch(clearCart());
                dispatch(getCurrentOrder());
                dispatch(reloadUser());
                return;
            }
            const newOrder = await OrderService.getOrder(state.orderId);
            console.log("ORDER", newOrder);
            setOrder(newOrder);
            dispatch(clearCart());
            dispatch(getCurrentOrder());
            dispatch(reloadUser());
        }
        fetchData();
    }, []);

    const formatPantsSize = (sizeName) => {
        var isFour = /^\d{4}$/.test(sizeName);
        if (isFour) {
            return sizeName.substring(0, 2) + "x" + sizeName.substring(2);
        } else {
            return sizeName;
        }
    }

    let totalCount = 0;
    return (
        <div className="container">
            {isDemo && (
                <div class="checkout-container">
                    <div style={{ backgroundColor: "#fff3cd", border: "2px solid #ffc107", borderRadius: "8px", padding: "30px", margin: "20px 0", textAlign: "center" }}>
                        <h2 style={{ color: "#856404", margin: "0 0 15px 0" }}>🛒 Demo Order Submitted</h2>
                        <p style={{ color: "#856404", fontSize: "18px", marginBottom: "15px" }}>
                            <strong>This was a demo order.</strong>
                        </p>
                        <p style={{ color: "#856404", marginBottom: "10px" }}>
                            A demo confirmation email has been sent to your email address.<br />
                            No actual order was placed and no payment was processed.
                        </p>
                        <p style={{ color: "#856404", marginBottom: "0" }}>
                            The order has been deleted from the system.
                        </p>
                    </div>
                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                        <Button variant="primary" href={homePath}>Continue Shopping</Button>
                    </div>
                </div>
            )}
            {order && !isDemo && (

                <div class="checkout-container">
                    <h2>Order # {order.id} </h2>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <h2>Delivering to {order.deliveryName}</h2>
                        <div style={{ marginLeft: 30, padding: 5, border: "1px solid #CCCCCC" }}>{order.deliveryAddress}<br />
                            {order.deliveryAddress2 != null && order.deliveryAddress2 != "" && <>{order.deliveryAddress2}<br /></>}
                            {order.deliveryCity}, {order.deliveryState} {order.deliveryZip}<br />
                        </div>
                    </div>

                    <div>
                        <div class="review-container">
                            <div class="content">

                                <div class="cart-item-container">
                                    {(currentSubsite.paymentOptions && (currentSubsite.paymentOptions != "itemlimit" && currentSubsite.paymentOptions != "kit")) && (
                                        <div class="price-label">PRICE</div>
                                    )}
                                    <Container className="mt-5" style={{ marginBottom: "150px" }}>
                                        {order && order.order_items && order.order_items.map(item => {
                                            // Print items: no product/style/color/size/decoration; render simpler row
                                            if (item.printItemId && item.print_item) {
                                                const pi = item.print_item;
                                                const piImage = pi.imageUrl
                                                    ? (pi.imageUrl.includes('uploads') ? apiUrl + pi.imageUrl : pi.imageUrl)
                                                    : null;
                                                const showPrice = currentSubsite.paymentOptions
                                                    && currentSubsite.paymentOptions != "itemlimit"
                                                    && currentSubsite.paymentOptions != "kit";
                                                return (
                                                    <Row className="checkout-item" key={item.id}>
                                                        <Col sm={3} className="d-flex justify-content-center align-items-center">
                                                            <div style={{ position: "relative", width: "150px" }}>
                                                                {piImage && <img className="bg-image" src={piImage} width={150}></img>}
                                                            </div>
                                                        </Col>
                                                        <Col sm={7}>
                                                            <div class="content" style={{ position: "relative" }}>
                                                                <div class="title">{pi.title}</div>
                                                                <div class="quantity">Quantity: {item.quantity}</div>
                                                                <div class="decorations">
                                                                    {(item.order_item_personalizations || []).map((p, idx) => (
                                                                        <div key={idx}>{p.fieldName}: {p.fieldValue}</div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        {showPrice && (
                                                            <Col sm={2}>
                                                                {pi.pricingType === PRICING_TYPES.BILL_LATER ? (
                                                                    <div class="price" style={{ textAlign: "right", justifyContent: "flex-end", fontStyle: "italic", color: "#666" }}>Billed Later</div>
                                                                ) : (
                                                                    /* Print item price is stored as the total for the line (flat: price*qty, tier: tier total) */
                                                                    <div class="price" style={{ textAlign: "right", justifyContent: "flex-end" }}>{(item.price).toLocaleString(undefined, { style: "currency", currency: "USD" })}</div>
                                                                )}
                                                            </Col>
                                                        )}
                                                    </Row>
                                                );
                                            }
                                            return (
                                                <Row className="checkout-item" key={item.id}>
                                                    <Col sm={3} className="d-flex justify-content-center align-items-center">
                                                        <div style={{ position: "relative", width: "150px" }}>
                                                            <img className="bg-image" src={resolveImageUrl(item.product.frontModelImage)} width={150}></img>
                                                            {item.decorations && item.decorations.map((logo, i) => (
                                                                <img className="logo-image" src={apiUrl + logo.decoration_logo.imageUrl} width={logo.width + '%'} style={{ left: logo.x + '%', top: logo.y + '%', transform: 'rotate(' + logo.rotate + 'deg)' }}></img>
                                                            )
                                                            )}

                                                        </div>
                                                    </Col>
                                                    <Col sm={7}>
                                                        <div class="content" style={{ position: "relative" }}>
                                                            <div class="title">{item.product.style.title}</div>
                                                            <div class="color">Color: {item.colorName}</div>
                                                            <div class="size-name">Size: {formatPantsSize(item.sizeName)}</div>
                                                            <div class="quantity">
                                                                Quantity: {item.quantity}
                                                            </div>
                                                            <div class="decorations">
                                                                {item.subsite_decos?.map(logo => {
                                                                    return "Decoration: " + logo.decoration_logo.decorationName + " - " + logo.deco_location.description;
                                                                })}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    {(currentSubsite.paymentOptions && (currentSubsite.paymentOptions != "itemlimit" && currentSubsite.paymentOptions != "kit")) && (

                                                        <Col sm={2}>
                                                            {/* For bill later, show "Billed Later" */}
                                                            {item.product?.pricingType === PRICING_TYPES.BILL_LATER ? (
                                                                <div class="price" style={{ textAlign: "right", justifyContent: "flex-end", fontStyle: "italic", color: "#666" }}>Billed Later</div>
                                                            ) : item.product?.pricingType === PRICING_TYPES.QUANTITY ? (
                                                                /* For quantity pricing, price is already the total for that tier */
                                                                <div class="price" style={{ textAlign: "right", justifyContent: "flex-end" }}>{(item.price).toLocaleString(undefined, { style: "currency", currency: "USD" })}</div>
                                                            ) : (
                                                                <div class="price" style={{ textAlign: "right", justifyContent: "flex-end" }}>{(item.price * item.quantity).toLocaleString(undefined, { style: "currency", currency: "USD" })}</div>
                                                            )}
                                                        </Col>
                                                    )}
                                                </Row>
                                            );
                                        })

                                        }
                                    </Container>
                                    {currentSubsite.paymentOptions != "itemlimit" && currentSubsite.paymentOptions != "kit" && (

                                        <div class="total">Shipping: <strong>{(order.shippingCost ? order.shippingCost : 0).toLocaleString(undefined, {
                                            style: "currency",
                                            currency: "USD",
                                        })}</strong></div>
                                    )}

                                    {order.paymentType === "balance" || order.paymentType === "creditcard" &&
                                        <div class="total">Balance Used: <strong style={{ color: "#990000" }}>({(order.balanceUsed ? order.balanceUsed : 0).toLocaleString(undefined, {
                                            style: "currency",
                                            currency: "USD",
                                        })})</strong></div>}

                                    {currentSubsite.paymentOptions != "itemlimit" && currentSubsite.paymentOptions != "kit" && (
                                        <div class="total">Total: <strong>{(order.orderCost ? order.orderCost : 0).toLocaleString(undefined, {
                                            style: "currency",
                                            currency: "USD",
                                        })}</strong></div>

                                    )}



                                </div>
                            </div>
                        </div>
                    </div>


                </div>

            )}
        </div>
    );
};
export default Confirm;